import { IUpdateRawQueryList } from '@models/Update.model';
import { UpdatesAssignedToMeQuery } from './UpdatesAssignedToMe.query';

interface IUpdatesAssignedToMe {
  data: IUpdateRawQueryList[];
  isLoading: boolean;
  isError: boolean;
  hasMore?: boolean;
  loadMore: () => void;
}

const UpdatesAssignedToMe = ({
  data,
  isLoading,
  isError,
  loadMore,
  hasMore,
}: IUpdatesAssignedToMe) => {
  return (
    <UpdatesAssignedToMeQuery
      data={data}
      isLoading={isLoading}
      isError={isError}
      loadMore={loadMore}
      hasMore={hasMore}
    />
  );
};

export { UpdatesAssignedToMe };
